/**
 * Created by daniel on 11/04/17.
 */
import React, {Component} from 'react';
import {List, ListItem, Paper} from "material-ui";
import {blue500} from "material-ui/styles/colors";

class Homepage extends Component {
  
  render() {
    return (
      <div style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%"
      }}>
        <div
          style={{
            width: "100%",
            //height: "15vh",
            backgroundColor: blue500,
            textAlign: "center",
            //lineHeight: "calc(15vh - 32px)",
          }}
        >
          <h1 style={{
            margin: 0,
            padding: "0 0 64px 0",
            fontWeight: "normal",
            fontSize: "60px",
            color: "#ffffff",
          }}
          >ABI HTML Email Editor</h1>
        </div>
        <div
          style={{
            margin: "0 auto",
            padding: "32px",
            fontSize: "40px",
            color: "#222222",
          }}
        >
          Select a template
        </div>
        <div
          style={{
            margin: "0 auto",
            flex: "0 1 auto",
            overflow: "auto",
            padding: "0 0 10px 0",
            //height: "100%"
            //width: "400px"
          }}
        >
          <Paper
            style={{
              width: "400px", 
              margin:"0 auto",
            }}
          >
            <List>
              <ListItem
                primaryText="Empty Template"
                secondaryText="A completely empty editor - good luck!"
                secondaryTextLines={2}
                onTouchTap={() => this.props.route.history.push("/editor")}
              />
              <ListItem
                primaryText="Basic Newsletter"
                secondaryText="An empty newsletter template, with slots for the author and team members"
                secondaryTextLines={2}
                onTouchTap={() => this.props.route.history.push("/editor/create/template/default")}
              />
              <ListItem
                primaryText="Events Marketing"
                secondaryText="A sample event mailing"
                secondaryTextLines={2}
                onTouchTap={() => this.props.route.history.push("/editor/create/template/events")}
              />
              <ListItem
                primaryText="Events - Keynote Speakers"
                secondaryText="Events marketing template for publicising keynote speakers"
                secondaryTextLines={2}
                onTouchTap={() => this.props.route.history.push("/editor/create/template/eventskeynote")}
              />
              <ListItem
                primaryText="Associate Members"
                secondaryText="Base associate members' newsletter"
                secondaryTextLines={2}
                onTouchTap={() => this.props.route.history.push("/editor/create/template/associatemembers")}
              />
              <ListItem
                primaryText="Outlook Email"
                secondaryText="A plain email imitating a standard Outlook message, with customisable signature"
                secondaryTextLines={2}
                onTouchTap={() => this.props.route.history.push("/editor/create/template/plainoutlook")}
              />
            </List>
          </Paper>
        </div>
      </div>
    );
  }
}

export default Homepage;


// WEBPACK FOOTER //
// ./src/App/Homepage/Homepage.js